// @ts-nocheck

import { keyBy as _keyBy, mapValues as _mapValues, map as _map } from 'lodash';

import { number as NumberUtils } from '../../../utils';

const basketReceiveFreebets = (state, action) => {
  const { data: nextFreebets } = action.payload;
  const { freebets } = state;
  const prevFreebets = _mapValues(freebets, (freebet) => ({
    ...freebet,
    deleted: true,
  }));
  const nextFreebetsById = _keyBy(
    _map(nextFreebets, (nextFreebet) => ({
      ...nextFreebet,
      freebetId: NumberUtils.castNumber(nextFreebet.freebetId),
    })),
    'freebetId',
  );
  const finalFreebets = { ...prevFreebets, ...nextFreebetsById };
  return {
    ...state,
    freebets: finalFreebets,
  };
};

export default basketReceiveFreebets;
